var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onOutsideClick,
          expression: "onOutsideClick",
        },
      ],
      staticClass: "dropdown-holder",
      class: { disabled: _vm.isDisabled, error: _vm.error },
    },
    [
      _c(
        "div",
        {
          staticClass: "value",
          on: {
            click: function ($event) {
              return _vm.toggle(true, $event)
            },
          },
        },
        [
          _c(
            "span",
            [
              _vm._t(
                "current",
                function () {
                  return [_vm._v(_vm._s(_vm.title))]
                },
                { title: _vm.title, option: _vm.selectedOption }
              ),
            ],
            2
          ),
          _vm.isSearchable && _vm.open
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                  {
                    name: "focus",
                    rawName: "v-focus",
                    value: _vm.isSearchable && _vm.open,
                    expression: "isSearchable && open",
                  },
                ],
                staticClass: "input-normal",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("cms.controls.dropdown.search"),
                  autocomplete: "off",
                },
                domProps: { value: _vm.searchQuery },
                on: {
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      )
                        return null
                      return _vm.moveHighlighted(1)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      )
                        return null
                      return _vm.moveHighlighted(-1)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.commitHighlightedItem()
                    },
                  ],
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.searchQuery = $event.target.value
                    },
                    function ($event) {
                      _vm.highlightedIndex = 0
                    },
                  ],
                },
              })
            : _vm._e(),
          _c("i", {
            ref: "chevron",
            staticClass: "icon magicon-arrow-down-1",
            on: {
              click: function ($event) {
                return _vm.toggle(false, $event)
              },
            },
          }),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.open,
              expression: "open",
            },
            {
              name: "inside-window",
              rawName: "v-inside-window",
              value: !_vm.maxHeight,
              expression: "!maxHeight",
            },
          ],
          ref: "droplist",
          staticClass: "droplist",
          style: _vm.dropListStyle,
        },
        _vm._l(_vm.resolvedOptions, function (option, index) {
          return _c(
            "a",
            {
              class: {
                active: _vm.value == option.value,
                highlighted: _vm.highlightedIndex == index,
              },
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.updateValue(option)
                },
              },
            },
            [
              _vm._t(
                "option",
                function () {
                  return [_vm._v(_vm._s(option.label))]
                },
                { option: option }
              ),
            ],
            2
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }